import { Rive } from "@rive-app/canvas";
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

// to load rive add class js-load-rive,
// attributes:   data-name (id), data-state-machines, data-init-animation, data-json, data-autoplay,
// to play rive when scrolled in screen add class:  js-play-rive-on-scrolled


let riveAnimations = []

export function loadElementRive(elements) {
  elements.each(function () {
    if (! this.classList.contains('loaded')) {
      this.classList.add('loaded')

      let name = this.getAttribute('data-name')
      let json = this.getAttribute('data-json')
      let autoplay = this.getAttribute('data-autoplay')
      let stateMachines = this.getAttribute('data-state-machines')
      if (!autoplay) autoplay = false


      if (json) {


        let canvas = $('<canvas/>', {'class': 'js-rive-canvas', id: name})
        $(this).html(canvas)


        let riveAnimation = new Rive({
          src: json,
          canvas: document.getElementById(name),
          autoplay: autoplay,
          stateMachines: 'State Machine 1',
          onLoad: () => {
            riveAnimation.resizeDrawingSurfaceToCanvas();
          }
        });

        riveAnimations.push(riveAnimation)

      }

    }
  })


}


export function playRive($el, animationName = ''){
  $el.each(function (i, el){
    let animation = getRiveAnimationByName($(el).data('name'))
    if (animation){
      if (animationName){
        animation.play(animationName)
      } else {
        animation.reset()
        animation.play()
      }
    }
  })

}


export function getRiveAnimationByName(name){
  let animation = ''
  riveAnimations.forEach(function(el){
    if (el.canvas.id === name){
      animation = el
    }
  })
  return animation
}



window.addEventListener('load', (event) => {
  loadElementRive($('.js-load-rive'))
  loadRiveFilesOnScroll()
})



// Play Lottie when scrolled in screen, to use add to js-lottie class: js-play-lottie-on-scrolled
export function loadRiveFilesOnScroll () {
  document.querySelectorAll('.js-play-rive-on-scrolled').forEach(function (el) {
    let loadOffset = el.getAttribute('data-load-offset') ? el.getAttribute('data-load-offset') : '100'
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom-=" + loadOffset + "px", // el top, screen bottom
      once: true,
      onEnter: () => {
        playRive($(el), $(el).data('init-animation'))
        el.classList.add('played', 'in-screen')
      }
    });
  })
}
